import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Grant } from 'src/models/grant';
import { CategoryService } from 'src/services/category.service';
import { CourseService } from 'src/services/course.service';

import { Category } from '../../../models/category';
import { CustomSnackbarService } from '../../../services/custom-snackbar.service';
import { GrantService } from '../../../services/grant.service';
import { dateIntervalValidator } from '../../../utils/validators';

@Component({
  selector: 'app-create-grant',
  templateUrl: './create-grant.component.html',
  styleUrls: ['./create-grant.component.scss']
})
export class CreateGrantComponent implements OnInit {
  /**
   * Form to create a grant
   */
  grantForm: FormGroup;

  campaings!: string[];

  /**
   * Course types
   */
  courseTypes!: Category[];

  facultyList!: Category[];

  grant?: Grant;

  /**
   * Constructor
   * @param dialogRef
   * @param builder
   * @param snackBarService
   * @param grantService
   * @param translateService
   */
  constructor(
    public dialogRef: MatDialogRef<CreateGrantComponent>,
    private builder: FormBuilder,
    private snackBarService: CustomSnackbarService,
    private grantService: GrantService,
    private translateService: TranslateService,
    private courseService: CourseService,
    private categoryService: CategoryService,
    @Inject(MAT_DIALOG_DATA) public data: {grant: Grant}
  ) {
    if (data) {
      this.grant = data.grant;
    }

    this.grantForm = this.builder.group({
      name: [this.grant ? this.grant.name : '', Validators.required],
      campaings: [this.grant ? this.grant.campaings : []],
      typeEuroinnovaIds: [this.grant ? this.grant.typeEuroinnovaIds : []],
      faculties: [this.grant ? this.grant.faculties : []],
      percentage: [this.grant ? this.grant.percentage : '', Validators.required],
      startDate: [this.grant ? this.grant.startDate : '', [Validators.required]],
      endDate: [this.grant ? this.grant.endDate : '', [Validators.required]],
    }, { validators: dateIntervalValidator });
  }

  ngOnInit(): void {
    this.courseService.getCampaigns().subscribe((data) => {
      this.campaings = data.campaings;
    });
    this.categoryService.listTypes().subscribe((categoryList) => {
      this.courseTypes = categoryList.items;
    });
    this.categoryService.listFaculties().subscribe((facultyList) => {
      this.facultyList = facultyList.items;
    })
  }

  createGrant(): void {
    const grantForm = this.grantForm.value;
    this.grantService.create(grantForm).subscribe(() => {
      this.snackBarService.present(
        this.translateService.instant('CreateGrantComponent.grantCreatedSuccessfully')
      );
      this.dialogRef.close(true);
    });
  }

  editGrant(): void {
    const grantForm = this.grantForm.value;
    if (this.grant) {
      this.grant.name = grantForm.name;
      this.grant.percentage = grantForm.percentage;
      this.grant.startDate = grantForm.startDate;
      this.grant.endDate = grantForm.endDate;
      this.grant.campaings = grantForm.campaings;
      this.grant.faculties = grantForm.faculties;
      this.grant.typeEuroinnovaIds = grantForm.typeEuroinnovaIds;
      this.grantService.editGrant(this.grant).subscribe(() => {
        this.snackBarService.present(
          this.translateService.instant('CreateGrantComponent.grantUpdatedSuccessfully')
        );
        this.dialogRef.close(true);
      })
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
